module.exports = __webpack_public_path__ + "static/vortune_main_1-eda88bf3a5674f42b7480a07e1ca2d2f.png";